import { xor } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { navigateToChangeInsightDetails } from '../../links/index.jsx';

const GroupsFilter = ({
  groups,
  selectedGroupIds,
  initiativeId,
  initiativeType,
}) => {
  const selectedCount = selectedGroupIds.length;

  const handleSelect = useCallback(
    (groupId) => {
      // Handle numeric IDs and special 'none' value
      if (!groupId || groupId === 'none') {
        // Toggle 'none' selection (use string 'none' as marker)
        return navigateToChangeInsightDetails(
          {
            groupIds: xor(selectedGroupIds, ['none']),
          },
          initiativeId,
          initiativeType
        );
      }

      const numericId = parseInt(groupId, 10);
      return navigateToChangeInsightDetails(
        {
          groupIds: xor(selectedGroupIds, [numericId]),
        },
        initiativeId,
        initiativeType
      );
    },
    [selectedGroupIds, initiativeId, initiativeType]
  );

  const renderMenuItem = useCallback(
    (status) => {
      const isActive = selectedGroupIds.includes(
        status.id === 'none' ? 'none' : status.id
      );

      return (
        <React.Fragment key={status.id}>
          <MenuItem
            active={isActive}
            eventKey={status.id.toString()}
            onSelect={handleSelect}
          >
            <span className={status.archived ? 'text-muted' : ''}>
              {status.name}
            </span>
          </MenuItem>
        </React.Fragment>
      );
    },
    [selectedGroupIds]
  );

  return (
    <div className="" style={{ flex: 1 }}>
      <div className="text-muted filter-label">Groups</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="statuses-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {[...groups, { id: 'none', name: 'None' }].map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
};

GroupsFilter.propTypes = {
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  selectedGroupIds: PropTypes.arrayOf(PropTypes.number),
};

GroupsFilter.defaultProps = {
  groups: [],
  selectedGroupIds: [],
};

export default GroupsFilter;
